import React from 'react';
import { ReaderPathCheck } from '../ReaderPathCheck';
interface QuickCheckProps {
  questionId: string;
  checkLabel?: string;
  confirmationText?: string;
}

/**
 * Light band wrapper for an inline ReaderPathCheck. Reuses the existing
 * component, question IDs, and scoring untouched.
 */
export function QuickCheck(props: QuickCheckProps) {
  return <section className="bg-paper px-6 py-14 md:px-10 md:py-20" aria-labelledby="quick-check-heading" data-id="element-936" data-mp="3n3bm2rcd17bk">
      <div className="mx-auto max-w-3xl md:max-w-4xl" data-id="element-937" data-mp="ologtkpq6ec1">
        <h2 id="quick-check-heading" className="sr-only" data-id="element-938" data-mp="jppo5kxd6a5t">
          Quick Check
        </h2>
        <ReaderPathCheck {...props} compact data-id="element-939" data-mp="eotjv693olzv" />
      </div>
    </section>;
}